import { ButtonHTMLAttributes, FunctionComponent } from 'react';
import styled, { css } from 'styled-components';
import LoadingSpinner from './LoadingSpinner';

const ButtonStyle = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 48px;
  border: 0px;
  border-radius: var(--radius);
  z-index: 0;
  line-height: normal;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.333px;
  user-select: none;
  background-color: #ff6e3d;
  color: #fff;

  transition: all 0.1s ease-in-out;
  transform: scale(1);

  &:hover {
    cursor: pointer;
    background: #ff5116;
  }

  &:active {
    transform: scale(0.96543);
  }

  ${({ disabled }) =>
    disabled &&
    css`
      opacity: 0.3;
      transition: opacity 333ms linear;

      &:hover {
        cursor: not-allowed;
      }
    `};
`;

const Spinner = styled.div`
  > div {
    transform: scale(${100 / 3 / 100});
  }
`;

type Props = {
  id?: string;
  children: any;
  disabled?: boolean;
  isLoading?: boolean;
  onClick?: () => void;
  autoFocus?: boolean;
  className?: string;
  style?: any;
} & ButtonHTMLAttributes<HTMLButtonElement>;

const Button: FunctionComponent<Props> = ({
  id = '',
  children,
  disabled = false,
  isLoading = false,
  onClick,
  autoFocus,
  className,
  style= {},
  ...props
}) => {
  const click = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.preventDefault();
    !isLoading && !disabled && onClick && onClick();
  };

  return (
    <ButtonStyle
      id={id}
      onClick={onClick ? (e:any) => click(e) : undefined}
      className={`btn ${className}`}
      disabled={disabled}
      autoFocus={autoFocus}
      style={{...style}}
      {...props}
    >
      {isLoading ? (
        <Spinner>
          <LoadingSpinner />
        </Spinner>
      ) : (
        children
      )}
    </ButtonStyle>
  );
};

export default Button;
